<!--
/**
* @name: List.vue
* @description: 权限管理
* @author: 于海威
* @create: 2020/08/07 17:51:37
* @update: 2020/08/07 17:51:37
*/
-->

<template>
  <y-view :loading="isLoading">
    <div slot="left" class="left-panel">
      <h3 class="page-title">权限列表</h3>
      <k-tree :data.sync="treeDataList" hasActions class="mt-1" selectedRule="some" keyField="id" childField="children" v-model="menuId" @toggle="onToggle"></k-tree>
    </div>
    <div class="right-content">
      <h3 class="page-title">全部权限</h3>
      <k-table :data="jurisdictionList" :height="$root.tableHeightXX" :rightFixedNumber="1" class="mt-1" :columns="initColumns()"></k-table>
    </div>
    <k-popup :show.sync="isShowAddMenu" :title="popupTitle" :layer="popupLayer" @after-ok="onSave">
      <y-popup-body size="small">
        <y-form titleWidth="90px" alignTitle="left">
          <y-form-item title="权限编号：">
            <k-input placeholder="权限编号由系统自动生成" block disabled v-model="editPara.id"></k-input>
          </y-form-item>
          <y-form-item title="权限名称：" required>
            <k-input placeholder="请输入权限名称" block v-model="editPara.name" v-validate="'required'"></k-input>
          </y-form-item>
          <y-form-item title="Icon：">
            <k-input placeholder="请输入icon路径" block v-model="editPara.icon"></k-input>
          </y-form-item>
          <y-form-item title="父级权限：" required>
            <k-select-tree
              v-validate="'required'"
              v-model="editPara.pid"
              layerMinWidthEqual
              keyField="id"
              childField="children"
              textField="name"
              :text="editPara.pname"
              :data.sync="treeDataList"
              clearable
              block
            ></k-select-tree>
          </y-form-item>
          <y-form-item title="排序：">
            <k-input placeholder="请输入排序权重" block v-model="editPara.sort"></k-input>
          </y-form-item>
          <y-form-item title="路径：">
            <k-input placeholder="请输入权限路径" block v-model="editPara.url"></k-input>
          </y-form-item>
          <y-form-item title="类型：" required>
            <div>
              <k-radio value="MENU" v-model="editPara.type">菜单</k-radio>
              <k-radio value="BUTTON">按钮</k-radio>
            </div>
          </y-form-item>
          <y-form-item title="备注：" align="top">
            <k-input tag="textarea" placeholder="请输入备注信息" block v-model="editPara.remark"></k-input>
          </y-form-item>
        </y-form>
      </y-popup-body>
    </k-popup>
  </y-view>
</template>

<script>
import {
  NESTLE_SYSTEM_BACK_SERVER_SYSTEM_PERMISSION_LIST,
  NESTLE_SYSTEM_BACK_SERVER_SYSTEM_PERMISSION_DELETE,
  NESTLE_SYSTEM_BACK_SERVER_SYSTEM_PERMISSION_SAVE,
  NESTLE_SYSTEM_BACK_SERVER_SYSTEM_PERMISSION_UPDATE,
  NESTLE_SYSTEM_BACK_SERVER_SYSTEM_PERMISSION_LIST_MENU_TREE,
} from "@/assets/modules/apiList";

const initPara = () => ({
  icon: "",
  id: "",
  name: "",
  pid: 0,
  pname: "",
  remark: "",
  sort: 0,
  type: "MENU",
  url: "",
});
export default {
  data() {
    return {
      menuId: "",
      isLoading: false,
      treeDataList: [],
      jurisdictionList: [],
      isShowAddMenu: false,
      isView: false,
      isEdit: false,
      editPara: initPara(),
      isSaving: false,
    };
  },
  watch: {
    isShowAddMenu(v) {
      if (!v) {
        this.editPara = initPara();
        if (this.isView) {
          this.isView = false;
        }
        if (this.isEdit) {
          this.isEdit = false;
        }
      }
    },
  },
  computed: {
    popupTitle() {
      if (this.isView) {
        return "查看权限";
      } else if (this.isEdit) {
        return "编辑权限";
      } else {
        return "新增权限";
      }
    },
    popupLayer() {
      if (this.isView) {
        return "header, body, close, mask";
      } else {
        return "header, body, footer, close, mask";
      }
    },
    // treeData() {
    //   return JSON.parse(JSON.stringify(this.jurisdictionList));
    // }
  },
  methods: {
    onToggle(menu) {
      let menuCopy = JSON.parse(JSON.stringify(menu));
      let tmpList = [];
      for (let i = 0; i < menuCopy.length; i++) {
        let tmpMenuName = "";
        if (i == 0) {
          tmpMenuName = menuCopy[i].name;
        } else {
          for (let j = 0; j <= i; j++) {
            let tmpMenuItem = menuCopy[j];
            if (j < i) {
              tmpMenuName += `${tmpMenuItem.name}-`;
            } else {
              tmpMenuName += tmpMenuItem.name;
            }
          }
        }
        let tmpObj = JSON.parse(JSON.stringify(menuCopy[i]));
        tmpObj.name = tmpMenuName;
        tmpList.push(tmpObj);
      }
      this.jurisdictionList = tmpList;
    },
    initColumns() {
      return [
        {
          name: "权限编号",
          field: "id",
          style: {
            width: 60,
          },
        },
        {
          name: "图标",
          field: "icon",
          style: {
            width: 60,
          },
        },
        {
          name: "所在菜单页面",
          field: "name",
          style: {
            width: 180,
          },
        },
        {
          name: "路径",
          field: "url",
          style: {
            width: 180,
          },
        },
        {
          name: "PID",
          field: "pid",
          style: {
            width: 60,
          },
        },
        {
          name: "排序",
          field: "sort",
          style: {
            width: 60,
          },
        },
        {
          name: "备注",
          field: "remark",
          style: {
            width: 180,
          },
        },
        {
          name: "操作",
          customRender: (row) => {
            const addButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onAdd(row);
                }}
              >
                新增
              </a>
            );
            const editButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onEdit(row);
                }}
              >
                编辑
              </a>
            );
            // const Button = <a href="javascript:void(0);" onClick={() => {this.onView(row)}}>查看</a>;
            const deleteButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onDelete(row);
                }}
              >
                删除
              </a>
            );
            if (row.id === 0) {
              return <div>{addButton}</div>;
            }
            return (
              <div>
                {addButton}&#12288;{editButton}&#12288;{deleteButton}
              </div>
            );
          },
        },
      ];
    },
    onSave() {
      if (this.isSaving) {
        return;
      }
      let para = JSON.parse(JSON.stringify(this.editPara));
      const { tip } = this.$root;
      if (para.name.replace(/\s*/, "").length < 1) {
        return tip("请输入权限名称");
      }
      if (para.id != 0 && !para.pid) {
        return tip("请选择父级权限");
      }
      // if (para.url.replace(/\s*/, '').length < 1) {
      //   return tip('请输入路径');
      // }
      this.isSaving = true;
      this.isLoading = true;
      let api = NESTLE_SYSTEM_BACK_SERVER_SYSTEM_PERMISSION_SAVE;
      if (this.isEdit) {
        api = NESTLE_SYSTEM_BACK_SERVER_SYSTEM_PERMISSION_UPDATE;
      }
      this.$fetch({
        api,
        para,
      })
        .then(() => {
          this.isSaving = false;
          this.isLoading = false;
          this.isShowAddMenu = false;
          this.getJurisdictionList();
        })
        .catch(() => {
          this.isSaving = false;
          this.isLoading = false;
        });
    },
    getJurisdictionList() {
      this.isLoading = true;
      this.$fetch({
        api: NESTLE_SYSTEM_BACK_SERVER_SYSTEM_PERMISSION_LIST_MENU_TREE,
        para: {},
      })
        .then((res) => {
          this.treeDataList = [
            {
              id: 0,
              name: "根节点",
              type: "MENU",
              sort: 0,
              pid: "",
              pname: "",
              children: res,
              __open__: true,
            },
          ];
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    onAdd(row) {
      let { id, name } = row;
      if (name.indexOf("-") > -1) {
        name = name.split("-").slice(-1)[0];
      }
      this.editPara.pid = id;
      this.editPara.pname = name;
      this.isShowAddMenu = true;
    },
    onEdit(row) {
      let editPara = JSON.parse(JSON.stringify(row));
      if (editPara.name.indexOf("-") > -1) {
        editPara.name = editPara.name.split("-").slice(-1)[0];
      }
      let tmp = "";
      const findParentNodeNameById = (id, arr) => {
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].id == id) {
            tmp = arr[i].name;
            break;
          }
          if (arr[i].children && arr[i].children.length) {
            findParentNodeNameById(id, arr[i].children);
          }
        }
      };
      if (editPara.pid === 0) {
        editPara.pname = "根节点";
      } else {
        findParentNodeNameById(editPara.pid, this.treeDataList);
        if (tmp) {
          editPara.pname = tmp;
        }
      }
      this.editPara = editPara;
      this.isEdit = true;
      this.isShowAddMenu = true;
    },
    onDelete(row) {
      this.$dialog({
        title: "提示",
        content: (
          <div>
            <p>是否确认删除该权限？</p>
            <p class="text-danger">(该操作不可恢复)</p>
          </div>
        ),
        ok: () => {
          this.isLoading = true;
          this.$fetch({
            api: NESTLE_SYSTEM_BACK_SERVER_SYSTEM_PERMISSION_DELETE,
            para: { id: parseInt(row.id) },
          })
            .then(() => {
              this.isLoading = false;
            })
            .catch(() => {
              this.isLoading = false;
            });
        },
      });
    },
  },
  created() {
    this.getJurisdictionList();
  },
};
</script>

<style lang="postcss" module="css">
.search_key {
  width: 160px;
}
</style>
